import { get, writable } from "svelte/store"
import { uebersetzungen } from "./config"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    push: false,
    pop: false,
}

export const location = writable(initLoc)

export const navstore = writable<{ [key: number]: NavElement[] }>({})
export const pfadstore = writable<{ [pfad: string]: NavElement }>({})

function spracheVonUrl(): string {
    return get(location)?.path?.match(/^\/en(\/.*)?$/) ? "en" : "de"
}

export const sprache = writable<string>(spracheVonUrl())

location.subscribe(() => {
    const s = get(sprache)
    const newS = spracheVonUrl()
    if (s != newS) {
        sprache.set(newS)
    }
})

export const i18n = writable((key: string): string => {
    return key
})
sprache.subscribe((l) => {
    if (l != "") {
        i18n.set((key: string) => {
            return (uebersetzungen[key] && uebersetzungen[key][l]) || key
        })
    }
})

export const ccTags = writable<string[]>([])

function updateCcTtags() {
    // @ts-ignore
    ccTags.set(window.ccLoadedTags || [])
}

if (typeof window !== "undefined") {
    window.addEventListener("ccInit", updateCcTtags)
    window.addEventListener("ccAccept", updateCcTtags)
}
